<template>
	<Link
		as="v-card"
		class="flex d-flex flex-column"
		ripple
		link
		tag="a"
		:href="
			$route('shop.' + type + '.products', {
				tenant: $page.props.tenant.id,
				outlet: outlet.uuid,
			})
		"
	>
		<v-img height="250" :src="outlet.image_url"></v-img>
		<v-card-title primary-title>
			{{ outlet.name }}
		</v-card-title>
		<v-card-text class="fill-height">
			<div v-html="outlet.description" v-line-clamp:20="3"></div>
		</v-card-text>
		<v-fade-transition>
			<v-overlay v-if="!outlet.is_openning" absolute color="secondary">
				<v-btn color="secondary" dark>{{ $t("label.closed") }}</v-btn>
			</v-overlay>
		</v-fade-transition>
	</Link>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},
	props: ["outlet", "type"],
};
</script>